module.exports = __webpack_public_path__ + "static/front-desk-e179a475f2f8759e2b24e840af788cbb.jpg";